import type { CategoryHierarchy } from '@/gen/ecom/models'

const findCategoryHierarchy = (
  categoryHierarchies: CategoryHierarchy[],
  categoryId?: string
): CategoryHierarchy | undefined => {
  for (const categoryHierarchy of categoryHierarchies) {
    if (categoryHierarchy.id === categoryId) {
      return categoryHierarchy
    }
    if (categoryHierarchy.subcategories) {
      const foundCategoryHierarchy: CategoryHierarchy | undefined = findCategoryHierarchy(
        categoryHierarchy.subcategories,
        categoryId
      )
      if (foundCategoryHierarchy) {
        return foundCategoryHierarchy
      }
    }
  }
}

const cutCategoryHierarchyByLevels = (
  categoryHierarchy: CategoryHierarchy,
  currentLevel: number,
  levelsIncluded?: number
): CategoryHierarchy => {
  if (levelsIncluded != null && currentLevel >= levelsIncluded) {
    const copy = { ...categoryHierarchy }
    delete copy.subcategories
    return copy
  }

  const hierarchyCopy = { ...categoryHierarchy }

  if (hierarchyCopy.subcategories) {
    hierarchyCopy.subcategories = hierarchyCopy.subcategories.map((subcategory) =>
      cutCategoryHierarchyByLevels(subcategory, currentLevel + 1, levelsIncluded)
    )
  }

  return hierarchyCopy
}

export const getCategoryHierarchy = (
  categoryHierarchy: Array<CategoryHierarchy>,
  categoryId?: string,
  levelsIncluded?: number
): CategoryHierarchy | undefined => {
  const foundCategoryHierarchy = findCategoryHierarchy(categoryHierarchy, categoryId)
  if (foundCategoryHierarchy && levelsIncluded) {
    return cutCategoryHierarchyByLevels(foundCategoryHierarchy, 1, levelsIncluded)
  }

  return foundCategoryHierarchy
}
